









































import Component, { mixins } from "vue-class-component";
import { dateJp, getDefaultMonth } from "../../types";
import TextMonthChangePicker from "../common/TextMonthChangePicker.vue";
import TextDayChangePicker from "../common/TextDayChangePicker.vue";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit, Watch, Ref } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";

@Component({
  components: {
    TextMonthChangePicker,
    TextDayChangePicker,
    LoadingDialog
  }
})
export default class AddMasterDialog extends mixins(AxiosMixin) {
  private yearmonth: string = getDefaultMonth();
  private userBaseDate: string = getDefaultMonth() + "-01";
  private updatedAt: string | null = null;
  private isActive = false;
  private disabled = false;

  @Watch("yearmonth")
  onYearmonthChanged(newYearmonth: string, oldYearmonth: string) {
    if (oldYearmonth != newYearmonth) {
      const date = new Date(newYearmonth + "-02");
      const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.userBaseDate = dateJp(last);
    }
  }

  public open() {
    this.yearmonth = getDefaultMonth();
    const date = new Date(this.yearmonth + "-02");
    const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.userBaseDate = dateJp(last);
    this.updatedAt = null;
    this.disabled = false;
    this.isActive = true;
  }

  public openUpdate(
    yearmonth: string,
    userUpdatedAt: string,
    updatedAt: string
  ) {
    this.yearmonth = yearmonth;
    // this.userBaseDate = userUpdatedAt;
    const date = new Date(this.yearmonth + "-02");
    const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.userBaseDate = dateJp(last);
    this.updatedAt = updatedAt;
    this.disabled = true;
    this.isActive = true;
  }

  private clickOk() {
    this.postJson(
      window.base_url + "/api/office/link/ibow",
      {
        base_date: this.userBaseDate,
        year_month: this.yearmonth.replace("-", ""),
        updated_at: this.updatedAt
      },
      res => {
        //IBR-640対応 エラーの場合は画面をリロードする
        if (res.data.code > 0) {
          alert(res.data.message + "\n\n画面を更新します。");
          location.reload();
          return;
        }
        this.reload();
        this.openResultDialog(res.data.message);
        this.isActive = false;
      }
    );
  }

  private clickCancel() {
    this.isActive = false;
  }

  @Emit()
  reload() {
    return;
  }

  @Emit()
  openResultDialog(message: string): string {
    return message;
  }
}
